export enum InventoryTransferStatus {
    Submitted = 'Submitted',
    PendingConfirmation = 'PendingConfirmation',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Unknown = 'Unknown',
}
